import { colors, space } from "shared/styles/constants";
import styled from "styled-components";

export const EventBlockTeaser = styled.div`
  @media print {
    border-top: 1px solid ${colors.grey5};
    border-right: 1px solid ${colors.grey5};
    border-bottom: 1px solid ${colors.grey5};
    border-left: 3px solid ${colors.grey5};
    margin-top: -${space.l};
  }
`;
